<template>
  <div style="background-color: white; min-height: 100vh">
    <Header />
    <div style="position: relative; color: white; font-family: 'mediumRoboto'">
      <!-- <img src="../../../assets/images/moon_blue_header.jpg" class="eventImg" /> -->
      <v-breadcrumbs
        divider="/"
        :items="breadcrumbs"
        class="breadcrumbs"
      ></v-breadcrumbs>
      <div class="eventHeader">
        <h1 class="eventTitle">Full Moon Paddle Tour</h1>
        <p class="eventSubtitle">Kayak/Paddleboard Tour</p>
      </div>
      <div class="eventRegistration">
        <img class="heroImg" src="../../../assets/images/moonlitHero.png" />
        <div class="participant-counter-wrapper">
          <img class="kayak" src="../../../assets/images/kayak.svg" />
          <div class="participant-counter whiteBackground">
            <div class="participant-wrapper">
              <h2>Registration</h2>
              <hr />
              <p v-if="nextEvent"># of Participants</p>
              <p v-else style="color: #494e53; font-size: 20px">
                All events for this season have concluded. Check back next year!
              </p>
              <v-row
                v-if="nextEvent"
                justify="start"
                class="counter-box"
                no-gutters
              >
                <v-col cols="auto">
                  <v-btn
                    icon
                    class="counter-button"
                    @click="decrease"
                    :disabled="count <= 1"
                  >
                    <v-icon>mdi-minus</v-icon>
                  </v-btn>
                </v-col>

                <v-col cols="auto">
                  <div class="counter-value">{{ count }}</div>
                </v-col>

                <v-col cols="auto">
                  <v-btn icon class="counter-button" @click="increase">
                    <v-icon>mdi-plus</v-icon>
                  </v-btn>
                </v-col>
              </v-row>
            </div>
            <div v-if="nextEvent" class="button-flex">
              <button class="signUpButton" @click="continueToWaiver()">
                Register Now
              </button>
            </div>
          </div>
        </div>
      </div>
      <div class="eventInfo">
        <h1>Event Information</h1>
        <div class="eventDetails">
          <div>
            <h3>Overview</h3>
            <p>
              Sand Hollow Reservoir is the best place to enjoy a moonlit paddle.
              Bring your kayaks or paddleboards and join the Park Ranger for a
              chat about the full moon and water safety before enjoying a
              peaceful paddle under the moon and stars. Kayaks/paddleboards will
              NOT be provided.
            </p>
            <p>Max capacity will be 40 kayakers - individual paddlers.</p>
            <h3>Date & Time</h3>
            <p v-if="nextEvent">The event is on {{ nextEventFormatted }}</p>
            <p v-else>No upcoming events scheduled.</p>

            <h3>Tickets Available</h3>
            <p>
              Everyone must pre-register, we will only have 40 kayakers and
              paddleboarders (individual paddlers) max capacity on this tour. If
              you are not pre-registered we can not ensure you will have a spot
              on the tour.
            </p>
          </div>
          <div>
            <h3>Location</h3>
            <p>
              The meeting point will be at the dive park. You may park in the
              dive park area to unload and then park at the main boat ramp.
            </p>
            <div class="button-flex">
              <button class="signUpButton" @click="getDirections()">
                Get Directions
              </button>
            </div>
            <h3>What to Bring</h3>
            <ul>
              <li>
                Kayak or paddleboard and paddle (must bring your own, they will
                NOT be provided.)
              </li>
              <li>Lifejacket</li>
              <li>Whistle (in case of emergency)</li>
              <li>White light - head lamps are best</li>
            </ul>
            <h3>Disclaimer</h3>
            <p>*This event may be canceled if weather is cloudy or bad.</p>
          </div>
        </div>
      </div>

      <div class="page-wrap-overview gray-wrap">
        <div class="overview-section gray-wrap">
          <div class="overview">
            <img src="../../../assets/images/call-icon.svg" />
            <h1>Questions</h1>
          </div>
          <hr />
          <div class="contact-info">
            <img src="../../../assets/images/Graphics.png" />
            <div class="contact-details">
              <p style="color: white">Please contact:</p>
              <p style="color: white; font-weight: 700">Carlie Mallo</p>
              <a href="tel:801-633-5270" class="phone">801-633-5270</a>
              <a href="mailto:cmallo@utah.gov" class="email">cmallo@utah.gov</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script src="https://sdks.shopifycdn.com/js-buy-sdk/v2/latest/index.umd.min.js"></script>
<script src="https://sdks.shopifycdn.com/buy-button/latest/buy-button-storefront.min.js"></script>
<script src="https://evey-files.s3.amazonaws.com/js/evey_buy_button.js"></script>

<script>
import Header from "../../../components/Header.vue";
import $ from "jquery";
export default {
  name: "Moonlit",
  metaInfo: {
    title: "Moonlit Paddle",
    meta: [
      {
        name: "description",
        content:
          "Purchase your day-use pass for Sand Hollow Moonlit Paddle Event.",
      },
    ],
  },
  components: {
    Header,
  },
  data() {
    return {
      breadcrumbs: [],
      varrientId: "45497776996505",
      count: 1,
      // All event dates for the 2026 season
      eventDates: [
        {
          month: 1,
          day: 2,
          hour: 18,
          minute: 30,
          label: "February 2nd",
          time: "6:30pm",
        }, // Feb 2 - 6:30pm
        {
          month: 2,
          day: 3,
          hour: 18,
          minute: 30,
          label: "March 3rd",
          time: "6:30pm",
        }, // Mar 3 - 6:30pm
        {
          month: 3,
          day: 1,
          hour: 19,
          minute: 45,
          label: "April 1st",
          time: "7:45pm",
        }, // Apr 1 - 7:45pm
        {
          month: 4,
          day: 1,
          hour: 20,
          minute: 45,
          label: "May 1st",
          time: "8:45pm",
        }, // May 1 - 8:45pm
        {
          month: 4,
          day: 30,
          hour: 20,
          minute: 45,
          label: "May 30th",
          time: "8:45pm",
        }, // May 30 - 8:45pm
        {
          month: 5,
          day: 29,
          hour: 21,
          minute: 15,
          label: "June 29th",
          time: "9:15pm",
        }, // Jun 29 - 9:15pm
        {
          month: 6,
          day: 29,
          hour: 20,
          minute: 45,
          label: "July 29th",
          time: "8:45pm",
        }, // Jul 29 - 8:45pm
        {
          month: 7,
          day: 28,
          hour: 20,
          minute: 30,
          label: "August 28th",
          time: "8:30pm",
        }, // Aug 28 - 8:30pm
        {
          month: 8,
          day: 28,
          hour: 20,
          minute: 15,
          label: "September 28th",
          time: "8:15pm",
        }, // Sep 28 - 8:15pm
        {
          month: 9,
          day: 25,
          hour: 18,
          minute: 0,
          label: "October 25th",
          time: "6:00pm",
        }, // Oct 25 - 6:00pm
        {
          month: 10,
          day: 25,
          hour: 18,
          minute: 0,
          label: "November 25th",
          time: "6:00pm",
        }, // Nov 25 - 6:00pm
      ],
      year: 2026,
    };
  },
  computed: {
    /**
     * Returns all upcoming events (date hasn't passed yet)
     */
    upcomingEvents() {
      const now = new Date();
      return this.eventDates.filter((event) => {
        const eventDate = new Date(
          this.year,
          event.month,
          event.day,
          event.hour,
          event.minute
        );
        return eventDate > now;
      });
    },
    /**
     * Returns the next upcoming event, or null if all events have passed
     */
    nextEvent() {
      return this.upcomingEvents.length > 0 ? this.upcomingEvents[0] : null;
    },
    /**
     * Formatted string for the next event date
     */
    nextEventFormatted() {
      if (!this.nextEvent) return "";
      return this.formatEventDate(this.nextEvent);
    },
  },
  methods: {
    formatEventDate(event) {
      const eventDate = new Date(
        this.year,
        event.month,
        event.day,
        event.hour,
        event.minute
      );
      const days = [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday",
      ];
      const dayOfWeek = days[eventDate.getDay()];
      const months = [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
      ];
      const monthName = months[eventDate.getMonth()];
      return `${dayOfWeek}, ${monthName} ${event.day}, ${this.year} at ${event.time}`;
    },
    increase() {
      this.count++;
    },
    decrease() {
      if (this.count > 1) this.count--;
    },
    toggleDropdown(key) {
      this.dropdowns[key] = !this.dropdowns[key];
    },
    continueToWaiver() {
      localStorage.setItem("numberOfParticipants", this.count);
      localStorage.setItem("eventMonth", this.nextEvent.month);
      this.$router.push(`/parks/UTSAND/moonlit/waiver/${this.varrientId}`);
    },
    getDirections() {
      const url =
        "https://www.google.com/maps/place/37%C2%B007'09.2%22N+113%C2%B022'59.1%22W/@37.1192222,-113.3830833,1203m/data=!3m2!1e3!4b1!4m4!3m3!8m2!3d37.1192222!4d-113.3830833?entry=ttu&g_ep=EgoyMDI1MDYyMy4yIKXMDSoASAFQAw%3D%3D";
      window.open(url, "_blank");
    },
  },
  created() {
    this.breadcrumbs = [
      { text: "Home", disabled: false, href: "/" },
      {
        text: "Sand Hollow State Park",
        disabled: false,
        href: "/parks/" + this.$route.params.name + "/dayuse",
      },
      { text: "Moonlit Paddle", disabled: true },
    ];
  },
};
</script>

<style scoped>
.eventHeader {
  display: flex;
  padding: 50px;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}
.eventTitle {
  font-size: 64px;
  font-weight: 700;
  margin-bottom: 20px;
  font-family: "boldRoboto";
  line-height: 1.2;
}
.eventSubtitle {
  font-size: 36px;
  font-weight: 400;
  margin: 0;
  font-family: "mediumRoboto";
}
.eventRegistration {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 20px;
  background-color: #e3e3ce;
}
.participant-counter-wrapper {
  display: inline-block;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
  background-color: #e3e3ce;
  width: 50%;
}
.participant-wrapper {
  display: flex;
  align-items: center;
  flex-direction: column;
  gap: 10px;
}
.participant-wrapper h2 {
  font-size: 48px;
  font-family: "Roboto";
  margin: 0px;
}
.counter-box {
  background-color: #f4f4f4;
  border-radius: 5px;
  border: 1px solid #ccc;
  padding: 4px 8px;
  display: inline-flex;
  align-items: center;
  margin-bottom: 20px !important;
}
.counter-button {
  min-width: 36px;
  height: 36px;
  color: #333;
}
.counter-value {
  width: 32px;
  text-align: center;
  font-size: 18px;
  font-weight: 500;
  line-height: 36px;
  color: #333;
}
.signUpButton {
  background: #727a35;
  border: 1px solid #96a145;
  box-sizing: border-box;
  border-radius: 48px;
  color: white;
  text-decoration: none;
  padding: 12px 20px;
  border-radius: 40px;
  font-size: 16px;
  line-height: 1.2;
  display: inline-block;
  font-weight: 1000;
  width: 250px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  transition: background-color 0.3s ease, box-shadow 0.3s ease;
}
.signUpButton:hover {
  background-color: #5f6c2c;
  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.25);
  cursor: pointer;
}
.heroImg {
  width: 50%;
}
.kayak {
  width: 15%;
}
hr {
  border: 1px solid #424242;
  width: 250px;
}
.eventInfo {
  padding: 50px;
  color: #494e53;
}
.eventInfo h1 {
  font-size: 32px;
}
.eventDetails {
  display: flex;
  justify-content: center;
  gap: 30px;
}
.eventDetails div {
  width: 50%;
}
.eventDetails h3 {
  font-family: "boldRoboto";
  font-size: 24px;
  margin-top: 20px;
}
.eventDetails p {
  font-family: "Roboto";
  font-size: 20px;
  margin-top: 10px;
}
.eventDetails li {
  font-family: "Roboto";
  font-size: 20px;
  margin-top: 10px;
}
.eventDetails .button-flex {
  margin-top: 10px;
}
.gray-wrap {
  background-color: #424242;
}
.gray-wrap hr {
  border: 0.5px solid white;
  width: 80%;
  margin-bottom: 20px;
}
.gray-wrap h1 {
  color: white;
}
.contact-info {
  display: flex;
  gap: 20px;
  align-items: center;
}
.contact-info a {
  color: white;
  font-size: 16px;
  font-family: roboto;
}
.page-wrap-overview {
  width: 100%;
  display: flex;
  justify-content: center;
}
.overview-section {
  display: flex;
  flex-direction: column;
  padding: 50px;
  width: 80%;
}
.overview {
  display: flex;
  align-items: center;
  gap: 20px;
  margin-bottom: 20px;
}
.contact-details {
  display: flex;
  flex-direction: column;
}
.breadcrumbs {
  margin: 18px 16px;
  padding-left: 24px;
}
.v-breadcrumbs ::v-deep(a) {
  color: #96a145 !important;
}
@media only screen and (max-width: 800px) {
  .eventRegistration {
    flex-direction: column;
    align-items: center;
  }
  .heroImg {
    width: 100%;
  }
  .participant-counter-wrapper {
    width: 100%;
    padding: 50px;
  }
  .eventDetails {
    flex-direction: column;
    width: 100%;
    align-items: center;
  }
  .eventDetails div {
    width: 100%;
  }
  .contact-info {
    flex-direction: column;
    align-items: flex-start;
  }
  .kayak {
    width: 30%;
  }
}
</style>
